import React, { useCallback, useEffect, useMemo, useState } from "react";

const API = {
  definitions: "/api/work-definitions.php",
  list: "/api/work-list.php",
  detail: "/api/work-detail.php",
  save: "/api/work-save.php",
  actionSave: "/api/work-action-save.php",
  transfer: "/api/work-transfer.php",
  stale: "/api/work-publisher-stale.php",
  dashboard: "/api/work-dashboard.php",
  complete: "/api/work-complete.php",
  delete: "/api/work-delete.php",
  reminderSave: "/api/work-reminder-save.php",
};

const statusText = {
  open: "Açık",
  in_progress: "Devam Ediyor",
  waiting: "Kapalı",
  completed: "Tamamlandı",
  cancelled: "İptal",
};

const priorityText = {
  low: "Düşük",
  normal: "Normal",
  high: "Yüksek",
  critical: "Kritik",
};

const WORKSPACE_CSS = `
  .wm-workspace {
    --wm-ink:#191714;
    --wm-muted:#786f63;
    --wm-line:#e3ddd3;
    --wm-paper:#fbfaf7;
    --wm-soft:#f4f1eb;
    --wm-gold:#b88a14;
    --wm-burgundy:#6f1d1b;
    color:#191714 !important;
    min-height:calc(100vh - 66px);
    background:#fbfaf7 !important;
    border:1px solid #ded8cf;
    box-shadow:0 18px 45px rgba(50,42,33,.06);
    overflow:hidden;
  }
  .wm-workspace * { box-sizing:border-box; }
  .wm-workspace button,
  .wm-workspace input,
  .wm-workspace select,
  .wm-workspace textarea { font-family:inherit; }
  .wm-workspace-topbar {
    height:34px;
    display:flex;
    align-items:center;
    justify-content:space-between;
    background:#171614 !important;
    color:#fff !important;
    padding:0 12px;
    border-bottom:2px solid #9e7a20;
    letter-spacing:.01em;
    width:100%;
    min-width:0;
    overflow:hidden;
  }
  .wm-workspace-topbar strong {
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }
  .wm-workspace-body {
    display:grid;
    grid-template-columns:56px minmax(0,1fr);
    min-height:calc(100vh - 104px);
    background:#fbfaf7 !important;
    transition:grid-template-columns .18s ease;
  }
  .wm-workspace-body.helper-open {
    grid-template-columns:250px minmax(0,1fr);
  }
  .wm-focus-rail {
    border-right:1px solid #d7d0c6;
    background:#f8f5ef !important;
    padding:0;
    overflow:hidden;
    min-width:0;
    transition:width .18s ease;
  }
  .wm-helper-collapsed {
    width:56px;
    min-height:100%;
    display:flex;
    flex-direction:column;
    align-items:center;
    gap:8px;
    padding:12px 7px;
    background:#f8f5ef !important;
  }
  .wm-helper-tab {
    width:40px !important;
    min-height:96px !important;
    border:1px solid #d4ccc1 !important;
    background:#fff !important;
    color:#645c53 !important;
    border-radius:3px !important;
    padding:8px 0 !important;
    font-size:9px !important;
    font-weight:800;
    cursor:pointer;
    writing-mode:vertical-rl;
    transform:rotate(180deg);
    letter-spacing:.05em;
  }
  .wm-helper-tab:hover {
    border-color:#a68129 !important;
    color:#775a13 !important;
    background:#fffaf0 !important;
  }
  .wm-helper-open {
    width:250px;
    padding:14px 12px 22px;
    background:#f8f5ef !important;
  }
  .wm-helper-open-head {
    display:flex;
    align-items:center;
    justify-content:space-between;
    gap:8px;
    margin-bottom:10px;
    padding-bottom:8px;
    border-bottom:1px solid #ddd6cc;
  }
  .wm-helper-open-head strong {
    font-size:10px;
    color:#3e3832;
  }
  .wm-helper-close {
    border:1px solid #d3cbc0 !important;
    background:#fff !important;
    color:#665e55 !important;
    min-height:26px !important;
    padding:0 8px !important;
    border-radius:2px !important;
    font-size:9px !important;
    cursor:pointer;
  }
  .wm-logo-box { display:none; }
  .wm-person-search {
    display:flex;
    align-items:center;
    gap:7px;
    padding:7px 3px;
    border-bottom:1px solid #777066;
    color:#4f4942;
    margin-bottom:14px;
  }
  .wm-person-search input {
    width:100%;
    border:0 !important;
    outline:0 !important;
    background:transparent !important;
    color:#25211d !important;
    font-size:12px !important;
    min-height:28px !important;
    padding:0 !important;
  }
  .wm-calendar {
    padding:4px 2px 14px;
    border-bottom:1px solid #e2dcd3;
  }
  .wm-calendar-head {
    display:flex;
    align-items:center;
    justify-content:space-between;
    margin-bottom:10px;
    font-size:12px;
    font-weight:800;
  }
  .wm-calendar-head button {
    border:0 !important;
    background:transparent !important;
    color:#4f4942 !important;
    min-height:24px !important;
    padding:0 4px !important;
    cursor:pointer;
  }
  .wm-calendar-week,
  .wm-calendar-grid {
    display:grid;
    grid-template-columns:repeat(7,1fr);
    gap:3px;
    text-align:center;
  }
  .wm-calendar-week {
    font-size:9px;
    color:#7f776d;
    margin-bottom:5px;
    font-weight:700;
  }
  .wm-day {
    border:0 !important;
    background:transparent !important;
    color:#332e29 !important;
    min-height:28px !important;
    padding:0 !important;
    font-size:10px !important;
    border-radius:3px !important;
    cursor:pointer;
  }
  .wm-day:hover { background:#eee8dd !important; }
  .wm-day.is-today {
    outline:1px solid #9b7830 !important;
    font-weight:800;
  }
  .wm-day.is-selected {
    background:#6f1d1b !important;
    color:#fff !important;
    outline:0 !important;
  }
  .wm-day.is-empty { visibility:hidden; }
  .wm-reminder-title {
    display:flex;
    align-items:center;
    justify-content:space-between;
    margin-top:16px;
    margin-bottom:9px;
    text-transform:uppercase;
    letter-spacing:.22em;
    font-size:9px;
    color:#776e63;
    font-weight:800;
  }
  .wm-reminder-list {
    display:flex;
    flex-direction:column;
    gap:7px;
    max-height:280px;
    overflow:auto;
  }
  .wm-reminder-card {
    border:1px solid #cfc7bb !important;
    background:#fff !important;
    padding:8px 9px;
    cursor:pointer;
    text-align:left;
    min-height:54px !important;
    border-radius:2px !important;
  }
  .wm-reminder-card:hover { border-color:#9c7b2b !important; }
  .wm-reminder-card .t { font-size:11px; font-weight:800; color:#2d2823; }
  .wm-reminder-card .m { margin-top:3px; font-size:9px; color:#8a8176; }
  .wm-reminder-empty {
    border:1px dashed #cfc7bb;
    padding:12px;
    color:#8b8379;
    font-size:10px;
    text-align:center;
  }
  .wm-main {
    padding:22px 26px 28px;
    background:#fbfaf7 !important;
    min-width:0;
  }
  .wm-top-commandbar{display:flex;align-items:center;justify-content:flex-end;gap:6px;margin-left:auto;white-space:nowrap}
  .wm-top-command{min-height:34px!important;padding:0 12px!important;border:1px solid #d0c8bd!important;background:#fff!important;color:#4d463f!important;border-radius:3px!important;font-size:10px!important;font-weight:800;cursor:pointer}
  .wm-top-command.primary{border-color:#b88b18!important;background:#c99a16!important;color:#17130b!important}
  .wm-top-command.danger{border-color:#d9b4af!important;color:#8b3029!important;background:#fff8f7!important}
  .wm-top-command:disabled{opacity:.45;cursor:not-allowed}
  .wm-main-head {
    display:flex;
    align-items:flex-start;
    justify-content:space-between;
    gap:16px;
    padding-bottom:18px;
    border-bottom:1px solid #ded8cf;
  }
  .wm-kicker {
    color:#a47712;
    font-size:9px;
    font-weight:900;
    letter-spacing:.30em;
    text-transform:uppercase;
  }
  .wm-main-title {
    margin-top:5px;
    font-size:24px;
    line-height:1.1;
    font-weight:900;
    color:#191714;
  }
  .wm-main-sub {
    margin-top:7px;
    color:#7b736a;
    font-size:12px;
  }
  .wm-new-button {
    border:1px solid #b68b24 !important;
    background:#c89a16 !important;
    color:#17130b !important;
    border-radius:4px !important;
    padding:9px 14px !important;
    min-height:36px !important;
    font-size:11px !important;
    font-weight:900;
    cursor:pointer;
    white-space:nowrap;
  }


  .wm-module-toolbar {
    display:flex;
    flex-wrap:wrap;
    align-items:center;
    gap:7px;
    margin:10px 0;
  }
  .wm-filter-btn {
    min-height:31px !important;
    padding:0 11px !important;
    border:1px solid #d4ccc1 !important;
    background:#fff !important;
    color:#5f574f !important;
    border-radius:2px !important;
    font-size:9px !important;
    font-weight:800;
    cursor:pointer;
  }
  .wm-filter-btn.is-active {
    border-color:#b88a14 !important;
    background:#fff5d8 !important;
    color:#75580f !important;
  }
  .wm-date-filter {
    min-height:31px !important;
    border:1px solid #d4ccc1 !important;
    background:#fff !important;
    color:#2d2823 !important;
    padding:0 8px !important;
    font-size:9px !important;
  }
  .wm-module-note {
    font-size:9px;
    color:#8b8177;
  }
  .wm-reminder-dashboard {
    display:grid;
    grid-template-columns:1.25fr 1.25fr .8fr;
    gap:10px;
    margin-top:12px;
  }
  .wm-module-card {
    border:1px solid #d9d2c8;
    background:#fff !important;
    min-width:0;
  }
  .wm-module-card h3 {
    margin:0;
    padding:9px 10px;
    background:#f4f0e8 !important;
    border-bottom:1px solid #ddd6cc;
    font-size:10px;
    color:#3c352f;
  }
  .wm-module-card-body { padding:9px; }
  .wm-reminder-row {
    border-bottom:1px solid #eee8df;
    padding:8px 4px;
    cursor:pointer;
  }
  .wm-reminder-row:last-child { border-bottom:0; }
  .wm-reminder-row:hover { background:#fffaf0 !important; }
  .wm-reminder-row strong { display:block;font-size:10px;color:#2d2823; }
  .wm-reminder-row span { display:block;margin-top:3px;font-size:9px;color:#81786e; }
  .wm-kpi-line {
    display:flex;
    justify-content:space-between;
    gap:12px;
    padding:8px 0;
    border-bottom:1px solid #eee8df;
    font-size:10px;
  }
  .wm-transfer-layout {
    display:grid;
    grid-template-columns:minmax(0,1.6fr) 340px;
    gap:12px;
    margin-top:12px;
  }
  .wm-transfer-row {
    display:grid;
    grid-template-columns:34px 120px minmax(180px,1fr) 130px 110px;
    min-height:42px;
    border-bottom:1px solid #eee8df;
    align-items:center;
  }
  .wm-transfer-row.header {
    background:#f4f0e8 !important;
    font-weight:900;
    color:#5f574f;
  }
  .wm-transfer-row > div { padding:7px 8px;font-size:9px;min-width:0; }
  .wm-transfer-side { padding:10px; }
  .wm-transfer-side select,
  .wm-transfer-side textarea {
    width:100%;
    border:1px solid #d4ccc1 !important;
    background:#fff !important;
    color:#2d2823 !important;
    padding:8px !important;
    font-size:10px !important;
    margin-bottom:8px;
  }
  .wm-transfer-side textarea { min-height:90px;resize:vertical; }
  .wm-report-grid {
    display:grid;
    grid-template-columns:repeat(4,minmax(0,1fr));
    gap:10px;
    margin-top:12px;
  }
  .wm-report-number { font-size:24px;font-weight:900;color:#25211d; }
  .wm-report-label { margin-top:3px;font-size:9px;color:#857b70;text-transform:uppercase;letter-spacing:.08em; }
  .wm-report-wide { grid-column:span 2; }
  .wm-performance-table {
    margin-top:12px;
    border:1px solid #d9d2c8;
    background:#fff !important;
  }
  .wm-performance-row {
    display:grid;
    grid-template-columns:minmax(150px,1.2fr) 90px 90px 90px 90px 140px;
    min-height:40px;
    border-bottom:1px solid #eee8df;
    align-items:center;
  }
  .wm-performance-row.header {
    background:#f4f0e8 !important;
    font-weight:900;
    color:#5d554d;
  }
  .wm-performance-row > div { padding:7px 9px;font-size:9px; }
  .wm-progress { height:7px;background:#eee8df;overflow:hidden; }
  .wm-progress > span { display:block;height:100%;background:#b88a14; }
  @media (max-width:1000px) {
    .wm-reminder-dashboard { grid-template-columns:1fr; }
    .wm-transfer-layout { grid-template-columns:1fr; }
    .wm-report-grid { grid-template-columns:repeat(2,1fr); }
    .wm-report-wide { grid-column:span 2; }
  }
  .wm-workarea-shell {
    width:100%;
    min-width:0;
    overflow-x:auto;
    overflow-y:visible;
  }
  .wm-work-grid {
    width:100%;
    min-width:1320px;
    border:1px solid #d7d0c6;
    background:#fff !important;
  }
  .wm-work-grid-header,
  .wm-work-grid-row,
  .wm-work-grid-newrow {
    display:grid;
    grid-template-columns:
      48px
      64px
      minmax(170px,1.25fr)
      minmax(125px,.9fr)
      minmax(125px,.9fr)
      minmax(120px,.85fr)
      142px
      142px
      96px
      92px;
    width:100%;
  }
  .wm-work-grid-header {
    min-height:34px;
    background:#f1eee8 !important;
    border-bottom:1px solid #d7d0c6;
  }
  .wm-work-grid-header > div {
    display:flex;align-items:center;padding:0 8px;border-right:1px solid #ddd6cc;
    font-size:9px;font-weight:900;color:#5e564e;text-transform:uppercase;letter-spacing:.055em;
    white-space:nowrap;overflow:hidden;text-overflow:ellipsis;
  }
  .wm-work-grid-row {
    min-height:44px;border-bottom:1px solid #eee8df;background:#fff !important;color:#2d2823;cursor:pointer;
  }
  .wm-work-grid-row:hover { background:#fff9eb !important; }
  .wm-work-grid-row.is-selected { background:#fff1c7 !important; }
  .wm-work-grid-row.is-overdue { box-shadow:inset 3px 0 #982f28; }
  .wm-work-grid-row > div {
    display:flex;align-items:center;min-width:0;padding:6px 8px;border-right:1px solid #eee8df;font-size:10px;
    overflow:hidden;text-overflow:ellipsis;white-space:nowrap;
  }
  .wm-work-grid-newrow { background:#fffdf7 !important;border-bottom:2px solid #b58a20; }
  .wm-work-grid-newrow > div { min-width:0;border-right:1px solid #e5ded5;background:#fff !important;position:relative; }
  .wm-work-grid-newrow input,.wm-work-grid-newrow select {
    width:100%;min-height:40px !important;border:0 !important;outline:0 !important;border-radius:0 !important;
    background:#fff !important;color:#29241f !important;padding:7px 8px !important;font-size:10px !important;box-shadow:none !important;
  }
  .wm-work-grid-extra {
    display:grid;grid-template-columns:1fr 1fr 1fr;width:100%;min-width:1320px;
    border-left:1px solid #d7d0c6;border-right:1px solid #d7d0c6;border-bottom:1px solid #d7d0c6;background:#fff !important;
  }
  .wm-work-grid-extra > label { min-width:0;border-right:1px solid #e5ded5; }
  .wm-work-grid-extra span { display:block;padding:5px 8px;background:#f8f6f2 !important;border-bottom:1px solid #e5ded5;font-size:8px;font-weight:900;color:#7c7369;text-transform:uppercase;letter-spacing:.06em; }
  .wm-work-grid-extra input,.wm-work-grid-extra textarea,.wm-work-grid-extra select {
    width:100%;min-height:40px !important;border:0 !important;outline:0 !important;border-radius:0 !important;background:#fff !important;color:#29241f !important;padding:7px 8px !important;font-size:10px !important;
  }
  .wm-work-grid-extra textarea { min-height:58px !important;resize:vertical; }

  .wm-grid-row-actions {
    display:flex;
    align-items:center;
    justify-content:flex-end;
    gap:5px;
    padding:5px 6px 4px;
    border-top:1px solid #e5ded5;
    background:#faf8f4 !important;
  }
  .wm-grid-row-actions button {
    min-height:31px !important;
    padding:0 11px !important;
    border-radius:2px !important;
    font-size:10px !important;
    font-weight:800;
    cursor:pointer;
  }
  .wm-grid-action-cancel {
    border:1px solid #d0c8bd !important;
    background:#fff !important;
    color:#5a524a !important;
  }
  .wm-grid-alarm {
    border:1px solid #d0c8bd !important;
    background:#fff !important;
    color:#5a524a !important;
  }
  .wm-grid-alarm.is-open {
    border-color:#b88a14 !important;
    background:#fff5d8 !important;
    color:#75580f !important;
  }

  .wm-grid-action-save {
    border:1px solid #b88b18 !important;
    background:#c99a16 !important;
    color:#17130b !important;
  }
  .wm-grid-action-close {
    width:31px !important;
    min-width:31px !important;
    padding:0 !important;
    border:1px solid #d2cbc1 !important;
    background:#fff !important;
    color:#842b25 !important;
    font-size:15px !important;
  }
  .wm-reminder-toggle-row {
    display:flex;
    align-items:center;
    justify-content:space-between;
    gap:10px;
    min-height:39px;
    padding:0 9px;
    background:#fff !important;
  }
  .wm-reminder-toggle-row button {
    border:1px solid #d3cbc0 !important;
    background:#faf8f4 !important;
    color:#5f574f !important;
    min-height:28px !important;
    padding:0 10px !important;
    border-radius:2px !important;
    font-size:9px !important;
    font-weight:800;
    cursor:pointer;
  }
  .wm-reminder-toggle-row button.is-open {
    border-color:#b88a14 !important;
    background:#fff7df !important;
    color:#76580f !important;
  }
  .wm-reminder-expand {
    display:grid;
    grid-template-columns:1fr 180px;
    border-top:1px solid #e5ded5;
    background:#fff !important;
  }
  .wm-reminder-expand > label {
    min-width:0;
    border-right:1px solid #e5ded5;
  }
  .wm-reminder-expand > label:last-child { border-right:0; }
  .wm-reminder-expand span {
    display:block;
    padding:5px 8px;
    background:#f8f6f2 !important;
    border-bottom:1px solid #e5ded5;
    font-size:8px;
    font-weight:900;
    color:#7c7369;
    text-transform:uppercase;
    letter-spacing:.06em;
  }
  .wm-reminder-expand input,
  .wm-reminder-expand select {
    width:100%;
    min-height:38px !important;
    border:0 !important;
    outline:0 !important;
    border-radius:0 !important;
    background:#fff !important;
    color:#29241f !important;
    padding:7px 8px !important;
    font-size:10px !important;
  }

  .wm-grid-command-row {
    display:flex;justify-content:flex-end;gap:7px;width:100%;min-width:1320px;padding:7px 8px;background:#f8f5ef !important;border:1px solid #d7d0c6;border-top:0;
  }
  .wm-grid-inline-results {
    position:absolute;z-index:90;top:100%;left:0;right:0;max-height:220px;overflow:auto;border:1px solid #cfc7bb;background:#fff !important;box-shadow:0 10px 24px rgba(46,39,31,.12);
  }
  .wm-grid-inline-results button { width:100%;border:0 !important;border-bottom:1px solid #eee8df !important;background:#fff !important;text-align:left;padding:8px !important;min-height:40px !important;border-radius:0 !important;color:#28231f !important;cursor:pointer; }
  .wm-grid-inline-results strong { display:block;font-size:10px; }
  .wm-grid-inline-results span { display:block;font-size:9px;color:#8b8177;margin-top:2px; }

  .wm-work-category-strip {
    display:grid;
    align-items:stretch;
    gap:0;
    width:100%;
    min-width:0;
    border:1px solid #d5cec4;
    background:#f4f0e8 !important;
    margin:14px 0 0;
    min-height:38px;
    overflow-x:auto;
    scrollbar-width:thin;
  }
  .wm-work-category-strip button {
    width:100% !important;
    min-width:110px !important;
    border:0 !important;
    border-right:1px solid #d8d1c7 !important;
    background:transparent !important;
    color:#675f56 !important;
    padding:0 15px !important;
    min-height:38px !important;
    border-radius:0 !important;
    font-size:10px !important;
    font-weight:800;
    white-space:nowrap;
    cursor:pointer;
  }
  .wm-work-category-strip button:hover {
    background:#fffaf0 !important;
    color:#6f5413 !important;
  }
  .wm-work-category-strip button.is-active {
    background:#fff !important;
    color:#6f5413 !important;
    box-shadow:inset 0 -2px #b88a14;
  }
  .wm-inline-entry {
    border:1px solid #d5cec4;
    border-top:0;
    background:#fff !important;
    padding:0;
    margin-bottom:14px;
  }
  .wm-inline-entry-head {
    display:flex;
    align-items:center;
    justify-content:space-between;
    min-height:34px;
    padding:0 10px;
    background:#f7f4ee !important;
    border-bottom:1px solid #ddd6cc;
  }
  .wm-inline-entry-head strong {
    font-size:10px;
    color:#3a342e;
  }
  .wm-inline-entry-head span {
    font-size:9px;
    color:#8a8176;
  }
  .wm-d365-grid {
    display:grid;
    grid-template-columns:150px 180px minmax(170px,1fr) 150px 160px;
    border-bottom:1px solid #e6e0d7;
  }
  .wm-d365-cell {
    min-width:0;
    border-right:1px solid #e6e0d7;
    background:#fff !important;
  }
  .wm-d365-cell:last-child { border-right:0; }
  .wm-d365-label {
    min-height:25px;
    display:flex;
    align-items:center;
    padding:0 8px;
    background:#f8f6f2 !important;
    border-bottom:1px solid #e8e2da;
    font-size:8px;
    font-weight:800;
    color:#7f766c;
    text-transform:uppercase;
    letter-spacing:.07em;
  }
  .wm-d365-input,
  .wm-d365-cell input,
  .wm-d365-cell select,
  .wm-d365-cell textarea {
    width:100%;
    border:0 !important;
    outline:0 !important;
    border-radius:0 !important;
    background:#fff !important;
    color:#29241f !important;
    padding:7px 8px !important;
    min-height:36px !important;
    font-size:10px !important;
    box-shadow:none !important;
  }
  .wm-d365-cell textarea {
    min-height:64px !important;
    resize:vertical;
  }
  .wm-d365-cell.is-wide { grid-column:span 2; }
  .wm-d365-actions {
    display:flex;
    justify-content:flex-end;
    align-items:center;
    gap:7px;
    padding:8px 10px;
    background:#faf8f4 !important;
  }
  .wm-inline-publisher {
    position:relative;
  }
  .wm-inline-results {
    position:absolute;
    z-index:70;
    top:100%;
    left:0;
    right:0;
    max-height:210px;
    overflow:auto;
    border:1px solid #cfc7bb;
    background:#fff !important;
    box-shadow:0 10px 24px rgba(46,39,31,.12);
  }
  .wm-inline-results button {
    width:100%;
    border:0 !important;
    border-bottom:1px solid #eee8df !important;
    background:#fff !important;
    text-align:left;
    padding:8px !important;
    min-height:40px !important;
    border-radius:0 !important;
    color:#28231f !important;
    cursor:pointer;
  }
  .wm-inline-results button:hover { background:#fbf5e7 !important; }
  .wm-inline-results strong { display:block; font-size:10px; }
  .wm-inline-results span { display:block; font-size:9px; color:#8b8177; margin-top:2px; }
  .wm-slim-search {
    width:280px;
    flex:0 0 280px;
  }

  .wm-quick-row {
    display:flex;
    align-items:center;
    gap:10px;
    margin:14px 0 15px;
    min-width:0;
  }
  .wm-search-wide {
    flex:1;
    min-width:220px;
    display:flex;
    align-items:center;
    gap:8px;
    border:1px solid #d6cfc5;
    background:#fff !important;
    padding:0 10px;
    min-height:38px;
  }
  .wm-search-wide input {
    flex:1;
    border:0 !important;
    outline:0 !important;
    background:transparent !important;
    color:#25211d !important;
    font-size:12px !important;
    min-height:34px !important;
    padding:0 !important;
  }
  .wm-segment {
    display:flex;
    border:1px solid #d6cfc5;
    background:#f5f1ea !important;
    padding:2px;
    gap:2px;
  }
  .wm-segment button {
    border:0 !important;
    background:transparent !important;
    color:#766e64 !important;
    min-height:31px !important;
    padding:0 10px !important;
    border-radius:2px !important;
    font-size:10px !important;
    font-weight:800;
    cursor:pointer;
  }
  .wm-segment button.is-active {
    background:#fff !important;
    color:#7b5d14 !important;
    box-shadow:0 1px 3px rgba(43,35,25,.10);
  }
  .wm-overview-strip {
    display:grid;
    grid-template-columns:repeat(4,minmax(0,1fr));
    gap:8px;
    margin-bottom:16px;
  }
  .wm-overview-pill {
    border-top:2px solid #a88023;
    background:#f5f1ea !important;
    padding:9px 11px;
    min-height:56px;
  }
  .wm-overview-pill .n {
    font-size:18px;
    font-weight:900;
    color:#25211d;
  }
  .wm-overview-pill .l {
    font-size:9px;
    color:#81786e;
    text-transform:uppercase;
    letter-spacing:.12em;
  }
  .wm-section-title {
    display:flex;
    align-items:center;
    justify-content:space-between;
    gap:10px;
    margin:18px 0 8px;
  }
  .wm-section-title h3 {
    margin:0;
    font-size:13px;
    color:#26211d !important;
    font-weight:900;
  }
  .wm-section-title span {
    font-size:9px;
    color:#8b8175;
  }
  .wm-task-table {
    border-top:1px solid #d8d1c7;
    border-bottom:1px solid #d8d1c7;
    background:#fff !important;
  }
  .wm-task-row {
    display:grid;
    grid-template-columns:32px 70px minmax(180px,1.3fr) minmax(130px,.9fr) 120px 92px;
    align-items:center;
    min-height:52px;
    border-bottom:1px solid #eee9e1;
    color:#302b26;
    cursor:pointer;
  }
  .wm-task-row:last-child { border-bottom:0; }
  .wm-task-row:hover { background:#fbf5e7 !important; }
  .wm-task-row.is-selected { background:#fff3cf !important; }
  .wm-task-row.is-overdue { box-shadow:inset 3px 0 #9a3028; }
  .wm-check {
    display:grid;
    place-items:center;
  }
  .wm-check button {
    width:16px !important;
    height:16px !important;
    min-height:16px !important;
    border:1px solid #aaa094 !important;
    background:#fff !important;
    padding:0 !important;
    border-radius:50% !important;
    cursor:pointer;
  }
  .wm-check button:hover { border-color:#8c6b18 !important; }
  .wm-task-time { font-size:10px; color:#82796f; }
  .wm-task-title { font-size:11px; font-weight:900; color:#211d19; }
  .wm-task-sub { margin-top:2px; font-size:9px; color:#8a8176; }
  .wm-task-owner { font-size:10px; color:#4f4841; }
  .wm-task-next { font-size:10px; color:#5d544b; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  .wm-priority {
    justify-self:end;
    font-size:9px;
    font-weight:800;
    padding:3px 7px;
    border:1px solid #d8d1c7;
    color:#72695f;
    background:#faf8f4 !important;
  }
  .wm-priority.high, .wm-priority.critical {
    border-color:#b97771;
    color:#7d2b25;
    background:#fff7f6 !important;
  }
  .wm-empty-main {
    min-height:160px;
    display:grid;
    place-items:center;
    color:#9a9187;
    font-size:12px;
    border:1px dashed #d8d1c7;
    background:#fff !important;
  }
  .wm-stale-bar {
    margin-top:14px;
    border-left:3px solid #8c2a24;
    background:#fff5f3 !important;
    padding:10px 12px;
    font-size:10px;
    color:#6e302b;
  }
  .wm-drawer-backdrop {
    position:fixed;
    inset:0;
    z-index:130;
    background:rgba(27,23,18,.28);
    display:flex;
    justify-content:flex-end;
  }
  .wm-drawer {
    width:min(520px,94vw);
    height:100%;
    overflow:auto;
    background:#fbfaf7 !important;
    border-left:1px solid #cbc4ba;
    box-shadow:-18px 0 48px rgba(40,34,27,.16);
    padding:20px;
    color:#211d19 !important;
  }
  .wm-drawer-head {
    display:flex;
    align-items:flex-start;
    justify-content:space-between;
    gap:12px;
    padding-bottom:14px;
    border-bottom:1px solid #ddd6cc;
  }
  .wm-drawer-close {
    border:1px solid #d2cbc1 !important;
    background:#fff !important;
    color:#4d463f !important;
    min-height:32px !important;
    padding:0 10px !important;
    border-radius:3px !important;
  }
  .wm-detail-grid {
    display:grid;
    grid-template-columns:1fr 1fr;
    gap:9px;
    margin:14px 0;
  }
  .wm-detail-field {
    border:1px solid #ddd6cc;
    background:#fff !important;
    padding:10px;
    min-height:64px;
  }
  .wm-detail-field .k { font-size:9px; color:#8a8176; text-transform:uppercase; letter-spacing:.08em; }
  .wm-detail-field .v { margin-top:4px; font-size:11px; color:#302a25; font-weight:700; }
  .wm-action-form {
    border-top:1px solid #ddd6cc;
    margin-top:16px;
    padding-top:14px;
  }
  .wm-action-form input,
  .wm-action-form select,
  .wm-action-form textarea,
  .wm-modal input,
  .wm-modal select,
  .wm-modal textarea {
    width:100%;
    border:1px solid #d6cfc5 !important;
    background:#fff !important;
    color:#28231f !important;
    border-radius:3px !important;
    padding:9px 10px !important;
    font-size:11px !important;
    outline:0 !important;
  }
  .wm-action-form textarea { min-height:78px; resize:vertical; }
  .wm-save-action {
    width:100%;
    background:#c99a16 !important;
    color:#17130b !important;
    border:1px solid #b98b13 !important;
    min-height:38px !important;
    font-weight:900;
    border-radius:3px !important;
  }
  .wm-timeline { margin-top:18px; border-top:1px solid #ddd6cc; padding-top:14px; }
  .wm-timeline-item { position:relative; padding:0 0 14px 18px; border-left:1px solid #d5cec4; }
  .wm-timeline-item:before { content:""; position:absolute; width:7px; height:7px; border-radius:50%; left:-4px; top:4px; background:#9c7824; }
  .wm-timeline-meta { font-size:9px; color:#90877c; }
  .wm-timeline-text { margin-top:3px; font-size:11px; color:#342e28; }
  .wm-modal-backdrop {
    position:fixed;
    inset:0;
    z-index:150;
    background:rgba(24,20,16,.34);
    display:grid;
    place-items:center;
    padding:20px;
  }
  .wm-modal {
    width:min(880px,96vw);
    max-height:90vh;
    overflow:auto;
    background:#fbfaf7 !important;
    color:#211d19 !important;
    border:1px solid #cfc8bd;
    box-shadow:0 24px 70px rgba(30,25,20,.20);
    padding:18px;
  }
  .wm-modal-grid { display:grid; grid-template-columns:1fr 1fr; gap:10px; }
  .wm-modal .span-2 { grid-column:1/-1; }
  .wm-modal label > span { display:block; font-size:9px; font-weight:800; color:#857c72; margin-bottom:4px; text-transform:uppercase; letter-spacing:.08em; }
  .wm-modal-actions { display:flex; justify-content:flex-end; gap:8px; margin-top:14px; }
  .wm-btn-secondary {
    border:1px solid #d0c8bd !important;
    background:#fff !important;
    color:#514a43 !important;
    min-height:36px !important;
    padding:0 13px !important;
    border-radius:3px !important;
  }
  .wm-btn-primary {
    border:1px solid #b88b18 !important;
    background:#c99a16 !important;
    color:#17130b !important;
    min-height:36px !important;
    padding:0 14px !important;
    border-radius:3px !important;
    font-weight:900;
  }

  .wm-user-line {
    margin-top:4px;
    font-size:10px;
    color:#857b70;
    font-weight:700;
  }
  .wm-person-picker { position:relative; margin-bottom:14px; }
  .wm-person-results {
    position:absolute;
    z-index:40;
    top:100%;
    left:0;
    right:0;
    max-height:240px;
    overflow:auto;
    border:1px solid #cfc7bb;
    background:#fff !important;
    box-shadow:0 12px 28px rgba(46,39,31,.12);
  }
  .wm-person-option {
    display:block;
    width:100%;
    border:0 !important;
    border-bottom:1px solid #eee8df !important;
    background:#fff !important;
    color:#2d2823 !important;
    text-align:left;
    padding:8px 9px !important;
    min-height:42px !important;
    cursor:pointer;
  }
  .wm-person-option:hover { background:#fbf5e7 !important; }
  .wm-person-option strong { display:block; font-size:11px; }
  .wm-person-option span { display:block; margin-top:2px; font-size:9px; color:#8b8177; }
  .wm-selected-person {
    border:1px solid #bdb4a7;
    background:#fff !important;
    padding:9px;
    margin-bottom:14px;
  }
  .wm-selected-person .name { font-size:11px; font-weight:900; color:#28231f; }
  .wm-selected-person .meta { margin-top:2px; font-size:9px; color:#8a8176; }
  .wm-selected-person .actions { display:flex; gap:6px; margin-top:7px; }
  .wm-selected-person .actions button {
    min-height:26px !important;
    padding:0 7px !important;
    border:1px solid #d3cbc0 !important;
    background:#faf8f4 !important;
    color:#5f574f !important;
    border-radius:2px !important;
    font-size:9px !important;
    cursor:pointer;
  }
  .wm-reminder-modal {
    width:min(520px,94vw);
    background:#fbfaf7 !important;
    color:#211d19 !important;
    border:1px solid #cfc8bd;
    box-shadow:0 24px 70px rgba(30,25,20,.20);
    padding:18px;
  }
  .wm-reminder-form { display:grid; gap:10px; margin-top:14px; }
  .wm-reminder-form label > span {
    display:block;
    font-size:9px;
    font-weight:800;
    color:#857c72;
    margin-bottom:4px;
    text-transform:uppercase;
    letter-spacing:.08em;
  }
  .wm-reminder-form select,
  .wm-reminder-form input,
  .wm-reminder-form textarea {
    width:100%;
    border:1px solid #d6cfc5 !important;
    background:#fff !important;
    color:#28231f !important;
    border-radius:3px !important;
    padding:9px 10px !important;
    font-size:11px !important;
    outline:0 !important;
  }
  .wm-reminder-form textarea { min-height:80px; resize:vertical; }


  .wm-search-and-types {
    display:grid;
    grid-template-columns:360px minmax(0,1fr);
    gap:8px;
    align-items:stretch;
    margin:14px 0 12px;
  }
  .wm-search-and-types .wm-search-wide {
    width:100%;
    min-width:0;
    flex:none;
  }
  .wm-search-and-types .wm-work-category-strip {
    margin:0;
    min-width:0;
    overflow-x:auto;
  }
  .wm-helper-badge {
    display:inline-flex;
    align-items:center;
    justify-content:center;
    min-width:18px;
    height:18px;
    padding:0 5px;
    border-radius:999px;
    background:#7a1f1b !important;
    color:#fff !important;
    font-size:8px;
    font-weight:900;
    margin-top:5px;
    writing-mode:horizontal-tb;
    transform:rotate(180deg);
  }
  .wm-reminder-alert {
    margin-top:12px;
    border-left:3px solid #9b2c25;
    background:#fff4f2 !important;
    padding:9px;
  }
  .wm-reminder-alert-title {
    display:flex;
    align-items:center;
    justify-content:space-between;
    gap:8px;
    margin-bottom:7px;
    color:#7a2a24;
    font-size:9px;
    font-weight:900;
    text-transform:uppercase;
    letter-spacing:.08em;
  }
  .wm-reminder-alert-item {
    display:block;
    width:100%;
    border:1px solid #e2c2be !important;
    background:#fff !important;
    color:#3a302d !important;
    text-align:left;
    padding:7px 8px !important;
    min-height:42px !important;
    border-radius:2px !important;
    margin-top:5px;
    cursor:pointer;
  }
  .wm-reminder-alert-item strong {
    display:block;
    font-size:10px;
    color:#5e211d;
  }
  .wm-reminder-alert-item span {
    display:block;
    margin-top:2px;
    font-size:9px;
    color:#8d605b;
  }
  @media (max-width: 1180px) {
    .wm-search-and-types {
      grid-template-columns:320px minmax(0,1fr);
    }
  }
  @media (max-width: 900px) {
    .wm-search-and-types {
      grid-template-columns:1fr;
    }
  }

  @media (max-width:1100px) {
    .wm-workspace-body { grid-template-columns:52px minmax(0,1fr); }
    .wm-workspace-body.helper-open { grid-template-columns:220px minmax(0,1fr); }
    .wm-helper-open { width:220px; }
    .wm-d365-grid { grid-template-columns:140px 160px minmax(160px,1fr); }
    .wm-slim-search { width:230px; flex-basis:230px; }
    .wm-task-row { grid-template-columns:30px 60px minmax(160px,1fr) 110px 90px; }
    .wm-task-next { display:none; }
  }
  @media (max-width:760px) {
    .wm-workspace-body,
    .wm-workspace-body.helper-open { grid-template-columns:1fr; }
    .wm-focus-rail { border-right:0; border-bottom:1px solid #d7d0c6; }
    .wm-helper-collapsed {
      width:100%;
      min-height:auto;
      flex-direction:row;
      justify-content:flex-start;
      padding:7px 10px;
    }
    .wm-helper-tab {
      width:auto !important;
      min-height:30px !important;
      writing-mode:horizontal-tb;
      transform:none;
      padding:0 10px !important;
    }
    .wm-helper-open { width:100%; }
    .wm-d365-grid { grid-template-columns:1fr; }
    .wm-d365-cell.is-wide { grid-column:auto; }
    .wm-slim-search { width:100%; flex-basis:100%; }
    .wm-focus-rail { border-right:0; border-bottom:1px solid #d7d0c6; }
    .wm-logo-box { display:none; }
    .wm-overview-strip { grid-template-columns:repeat(2,1fr); }
    .wm-task-row { grid-template-columns:28px 54px minmax(140px,1fr) 86px; }
    .wm-task-owner,.wm-task-next { display:none; }
    .wm-modal-grid { grid-template-columns:1fr; }
    .wm-modal .span-2 { grid-column:auto; }
  }
`;

function pad(n) {
  return String(n).padStart(2, "0");
}

function nowDateTimeLocal() {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

function toDateKey(value) {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(String(value).replace(" ", "T"));
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

function showDate(value) {
  if (!value) return "-";
  const d = new Date(String(value).replace(" ", "T"));
  return Number.isNaN(d.getTime()) ? value : d.toLocaleString("tr-TR");
}

function showTime(value) {
  if (!value) return "--:--";
  const d = new Date(String(value).replace(" ", "T"));
  if (Number.isNaN(d.getTime())) return "--:--";
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

function isOverdue(item) {
  if (item?.status === "completed" || item?.status === "cancelled") return false;
  const target = item?.next_action_at || item?.due_at;
  if (!target) return false;
  const d = new Date(String(target).replace(" ", "T"));
  return !Number.isNaN(d.getTime()) && d.getTime() < Date.now();
}

async function jsonFetch(url, options = {}) {
  const response = await fetch(url, options);
  const text = await response.text();

  let data;
  try {
    data = JSON.parse(text);
  } catch {
    const preview = text.slice(0, 120).replace(/\s+/g, " ").trim();
    throw new Error(preview ? `API geçerli JSON döndürmedi: ${preview}` : "API boş cevap döndürdü.");
  }

  if (!response.ok || data.success === false) {
    throw new Error(data.message || `İşlem başarısız. HTTP ${response.status}`);
  }

  return data;
}

function getPublisherManagerUsername(p) {
  return String(
    p?.assignedEmployeeUsername ||
      p?.employeeUsername ||
      p?.managerUsername ||
      p?.representative ||
      p?.raw?.assignedEmployeeUsername ||
      p?.raw?.employeeUsername ||
      p?.raw?.managerUsername ||
      p?.raw?.representative ||
      ""
  ).trim();
}

export default function WorkManagementCenter({
  activeModule = "work_center",
  currentUsername = "",
  publishers = [],
  managers = [],
}) {
  const today = useMemo(() => new Date(), []);
  const [calendarMonth, setCalendarMonth] = useState(
    new Date(today.getFullYear(), today.getMonth(), 1)
  );
  const [helperPanelOpen, setHelperPanelOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(toDateKey(today));
  const [definitions, setDefinitions] = useState([]);
  const [items, setItems] = useState([]);
  const [summary, setSummary] = useState({});
  const [stale, setStale] = useState([]);
  const [error, setError] = useState("");
  const [q, setQ] = useState("");
  const [personSearch, setPersonSearch] = useState("");
  const [personPickerOpen, setPersonPickerOpen] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [showReminderModal, setShowReminderModal] = useState(false);
  const [reminderForm, setReminderForm] = useState({
    work_item_id: "",
    reminder_at: "",
    note: "",
  });
  const [selected, setSelected] = useState(null);
  const [detail, setDetail] = useState(null);
  const [showNew, setShowNew] = useState(false);
  const [selectedMainType, setSelectedMainType] = useState("");
  const [publisherScope, setPublisherScope] = useState("");
  const [publisherSearch, setPublisherSearch] = useState("");
  const [publisherSearchOpen, setPublisherSearchOpen] = useState(false);
  const [form, setForm] = useState({
    work_type_id: "",
    publisher_user_id: "",
    publisher_hidden_id: "",
    publisher_username: "",
    publisher_name: "",
    title: "",
    description: "",
    status: "waiting",
    priority: "normal",
    owner_username: currentUsername,
    start_at: "",
    due_at: "",
    next_action: "",
    next_action_at: "",
    where_left_off: "",
    reminder_enabled: false,
    reminder_at: "",
    reminder_repeat: "none",
    reminder_target_username: currentUsername,
  });
  const [deskFilter, setDeskFilter] = useState("all");
  const [deskDate, setDeskDate] = useState(toDateKey(today));
  const [showAllDeskItems, setShowAllDeskItems] = useState(false);
  const [selectedTransferIds, setSelectedTransferIds] = useState([]);
  const [transferTarget, setTransferTarget] = useState("");
  const [transferReason, setTransferReason] = useState("");
  const [action, setAction] = useState({
    action_type: "note",
    action_text: "",
    result_text: "",
    next_action: "",
    next_action_at: "",
    where_left_off: "",
  });

  const moduleMode = {
    work_center: "desk",
    work_reminders: "reminders",
    work_transfer: "transfer",
    work_reports: "reports",
    work_performance: "performance",
  }[activeModule] || "desk";

  const load = useCallback(async () => {
    try {
      setError("");
      const [listResult, summaryResult, staleResult] = await Promise.all([
        jsonFetch(API.list),
        jsonFetch(API.dashboard),
        jsonFetch(API.stale).catch(() => ({ items: [] })),
      ]);
      setItems(listResult.items || []);
      setSummary(summaryResult.summary || {});
      setStale(staleResult.items || []);
    } catch (e) {
      setError(e.message || "Veriler alınamadı.");
    }
  }, []);

  useEffect(() => {
    jsonFetch(API.definitions)
      .then((d) => setDefinitions(d.items || []))
      .catch((e) => setError(e.message || "İş tanımları alınamadı."));
    load();
  }, [load]);

  useEffect(() => {
    if (!showNew) return;
    setForm((f) => ({
      ...f,
      due_at: f.due_at || nowDateTimeLocal(),
      reminder_target_username:
        f.reminder_target_username || f.owner_username || currentUsername,
    }));
  }, [showNew, currentUsername]);

  const allowedMainTypeNames = useMemo(
    () => [
      "Yayıncı Yönetimi",
      "Etkinlik Yönetimi",
      "Kampanya Yönetimi",
      "Toplantılar",
      "Operasyonel İşler",
      "Raporlama ve Kontrol",
      "Yönetim İşleri",
    ],
    []
  );

  const topTypes = useMemo(() => {
    const filtered = definitions.filter(
      (x) =>
        Number(x.level) === 1 &&
        allowedMainTypeNames.includes(String(x.name || "").trim())
    );

    return [
      ...filtered,
      { id: "__other__", name: "Diğer", level: 1, is_virtual: true },
    ];
  }, [definitions, allowedMainTypeNames]);
  const childTypes = useMemo(
    () => definitions.filter((x) => Number(x.level) === 2),
    [definitions]
  );

  const personOptions = useMemo(() => {
    const query = personSearch.trim().toLocaleLowerCase("tr-TR");
    const rows = [...(publishers || [])];

    rows.sort((a, b) =>
      String(a?.username || a?.fullName || "").localeCompare(
        String(b?.username || b?.fullName || ""),
        "tr"
      )
    );

    if (!query) return rows.slice(0, 30);

    return rows
      .filter((p) =>
        [
          p?.username,
          p?.fullName,
          p?.full_name,
          p?.hiddenId,
          p?.hidden_id,
        ]
          .filter(Boolean)
          .some((value) =>
            String(value).toLocaleLowerCase("tr-TR").startsWith(query)
          )
      )
      .slice(0, 30);
  }, [publishers, personSearch]);

  const filteredItems = useMemo(() => {
    const query = q.trim().toLocaleLowerCase("tr-TR");
    return items.filter((item) => {
      if (query) {
        const haystack = [
          item.work_no,
          item.title,
          item.publisher_name,
          item.publisher_username,
          item.owner_username,
          item.next_action,
          item.work_type_name,
          item.parent_type_name,
        ]
          .filter(Boolean)
          .join(" ")
          .toLocaleLowerCase("tr-TR");

        if (!haystack.includes(query)) return false;
      }

      if (selectedPerson) {
        const selectedId = String(selectedPerson.id || "");
        const selectedUsername = String(selectedPerson.username || "");
        const selectedHiddenId = String(
          selectedPerson.hiddenId || selectedPerson.hidden_id || ""
        );

        const matchesPerson =
          (selectedId && String(item.publisher_user_id || "") === selectedId) ||
          (selectedUsername &&
            String(item.publisher_username || "") === selectedUsername) ||
          (selectedHiddenId &&
            String(item.publisher_hidden_id || "") === selectedHiddenId);

        if (!matchesPerson) return false;
      }

      return true;
    });
  }, [items, q, selectedPerson]);

  const deskFilteredItems = useMemo(() => {
    const now = new Date();
    const todayKey = toDateKey(now);

    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    const yesterdayKey = toDateKey(yesterday);

    const weekStart = new Date(now);
    weekStart.setDate(now.getDate() - 6);
    weekStart.setHours(0, 0, 0, 0);

    const rows = [...filteredItems].sort((a, b) => {
      const da = new Date(String(a.created_at || a.due_at || "").replace(" ", "T"));
      const db = new Date(String(b.created_at || b.due_at || "").replace(" ", "T"));
      return db - da;
    });

    return rows.filter((item) => {
      const raw = item.created_at || item.due_at;
      if (!raw) return deskFilter === "all";

      const d = new Date(String(raw).replace(" ", "T"));
      if (Number.isNaN(d.getTime())) return deskFilter === "all";

      const key = toDateKey(d);

      if (deskFilter === "today") return key === todayKey;
      if (deskFilter === "yesterday") return key === yesterdayKey;
      if (deskFilter === "week") return d >= weekStart && d <= now;
      if (deskFilter === "date") return key === deskDate;
      return true;
    });
  }, [filteredItems, deskFilter, deskDate]);

  const deskPreviewItems = useMemo(
    () => (showAllDeskItems ? deskFilteredItems : deskFilteredItems.slice(0, 10)),
    [deskFilteredItems, showAllDeskItems]
  );

  const futureReminders = useMemo(() => {
    const now = Date.now();
    return [...items]
      .filter((item) => {
        if (Number(item.reminder_enabled) !== 1 || !item.reminder_at) return false;
        if (item.status === "completed" || item.status === "cancelled") return false;
        const d = new Date(String(item.reminder_at).replace(" ", "T"));
        return !Number.isNaN(d.getTime()) && d.getTime() > now;
      })
      .sort(
        (a, b) =>
          new Date(String(a.reminder_at).replace(" ", "T")) -
          new Date(String(b.reminder_at).replace(" ", "T"))
      );
  }, [items]);

  const reportSummary = useMemo(() => {
    const total = items.length;
    const completed = items.filter((x) => x.status === "completed").length;
    const open = items.filter(
      (x) => x.status !== "completed" && x.status !== "cancelled"
    ).length;
    const overdue = items.filter(isOverdue).length;
    const critical = items.filter((x) => x.priority === "critical").length;

    const byType = new Map();
    items.forEach((item) => {
      const key = item.parent_type_name || "Diğer";
      byType.set(key, (byType.get(key) || 0) + 1);
    });

    return {
      total,
      completed,
      open,
      overdue,
      critical,
      completionRate: total ? Math.round((completed / total) * 100) : 0,
      byType: [...byType.entries()]
        .map(([name, count]) => ({ name, count }))
        .sort((a, b) => b.count - a.count),
    };
  }, [items]);

  const managerPerformance = useMemo(() => {
    const map = new Map();

    items.forEach((item) => {
      const manager = item.owner_username || "Atanmamış";

      if (!map.has(manager)) {
        map.set(manager, {
          manager,
          total: 0,
          completed: 0,
          open: 0,
          overdue: 0,
          reminders: 0,
        });
      }

      const row = map.get(manager);
      row.total += 1;

      if (item.status === "completed") row.completed += 1;
      else if (item.status !== "cancelled") row.open += 1;

      if (isOverdue(item)) row.overdue += 1;
      if (Number(item.reminder_enabled) === 1) row.reminders += 1;
    });

    return [...map.values()]
      .map((row) => ({
        ...row,
        completionRate: row.total
          ? Math.round((row.completed / row.total) * 100)
          : 0,
      }))
      .sort(
        (a, b) =>
          b.completionRate - a.completionRate ||
          b.completed - a.completed
      );
  }, [items]);

  const reminders = useMemo(() => {
    return [...items]
      .filter((item) => Number(item.reminder_enabled) === 1 && item.reminder_at)
      .sort(
        (a, b) =>
          new Date(String(a.reminder_at).replace(" ", "T")) -
          new Date(String(b.reminder_at).replace(" ", "T"))
      )
      .slice(0, 8);
  }, [items]);


  const dueReminders = useMemo(() => {
    const now = Date.now();

    return [...items]
      .filter((item) => {
        if (Number(item.reminder_enabled) !== 1 || !item.reminder_at) return false;
        if (item.status === "completed" || item.status === "cancelled") return false;

        const d = new Date(String(item.reminder_at).replace(" ", "T"));
        return !Number.isNaN(d.getTime()) && d.getTime() <= now;
      })
      .sort(
        (a, b) =>
          new Date(String(a.reminder_at).replace(" ", "T")) -
          new Date(String(b.reminder_at).replace(" ", "T"))
      );
  }, [items]);

  const selectedDateItems = useMemo(
    () =>
      items.filter(
        (item) =>
          toDateKey(item.next_action_at || item.due_at) === selectedDate &&
          item.status !== "completed" &&
          item.status !== "cancelled"
      ),
    [items, selectedDate]
  );

  const openCount = Number(summary.open || 0);
  const todayCount = Number(summary.today || 0);
  const overdueCount = Number(summary.overdue || 0);
  const reminderCount = Number(summary.reminders || 0);

  const calendarCells = useMemo(() => {
    const year = calendarMonth.getFullYear();
    const month = calendarMonth.getMonth();
    const first = new Date(year, month, 1);
    const mondayIndex = (first.getDay() + 6) % 7;
    const days = new Date(year, month + 1, 0).getDate();
    const cells = [];

    for (let i = 0; i < mondayIndex; i += 1) cells.push(null);
    for (let day = 1; day <= days; day += 1) {
      cells.push(new Date(year, month, day));
    }
    while (cells.length % 7 !== 0) cells.push(null);
    return cells;
  }, [calendarMonth]);

  function moveMonth(amount) {
    setCalendarMonth(
      (m) => new Date(m.getFullYear(), m.getMonth() + amount, 1)
    );
  }

  async function openDetail(id) {
    try {
      const d = await jsonFetch(`${API.detail}?id=${id}`);
      setSelected(id);
      setDetail(d);
    } catch (e) {
      setError(e.message || "İş detayı alınamadı.");
    }
  }

  function closeDetail() {
    setSelected(null);
    setDetail(null);
  }

  function selectManager(username) {
    const isAll = username === "__all__";
    setPublisherScope(username);
    setForm((f) => ({
      ...f,
      owner_username: isAll ? currentUsername || f.owner_username : username,
      reminder_target_username: isAll
        ? currentUsername || f.owner_username
        : username,
      publisher_user_id: "",
      publisher_hidden_id: "",
      publisher_username: "",
      publisher_name: "",
    }));
    setPublisherSearch("");
    setPublisherSearchOpen(false);
  }

  function selectPublisher(p) {
    setForm((f) => ({
      ...f,
      publisher_user_id: p?.id || "",
      publisher_hidden_id: p?.hiddenId || p?.hidden_id || "",
      publisher_username: p?.username || "",
      publisher_name: p?.fullName || p?.full_name || "",
    }));
    setPublisherSearch(
      p?.username || p?.fullName || p?.full_name || ""
    );
    setSelectedPerson(p || null);
    setPublisherSearchOpen(false);
  }

  const managerPublishers = useMemo(() => {
    if (!publisherScope) return [];
    if (publisherScope === "__all__") return publishers || [];
    return (publishers || []).filter(
      (p) => getPublisherManagerUsername(p) === String(publisherScope)
    );
  }, [publishers, publisherScope]);

  const filteredManagerPublishers = useMemo(() => {
    const query = publisherSearch.trim().toLocaleLowerCase("tr-TR");
    if (!query) return managerPublishers.slice(0, 30);

    return managerPublishers
      .filter((p) =>
        [
          p?.username,
          p?.fullName,
          p?.full_name,
          p?.hiddenId,
          p?.hidden_id,
        ]
          .filter(Boolean)
          .some((value) =>
            String(value).toLocaleLowerCase("tr-TR").startsWith(query)
          )
      )
      .slice(0, 30);
  }, [managerPublishers, publisherSearch]);

  function chooseMainType(typeId) {
    setSelectedMainType(String(typeId));
    const isOther = String(typeId) === "__other__";
    const fallbackOtherType =
      childTypes.find((child) => {
        const parent = definitions.find(
          (x) => String(x.id) === String(child.parent_id)
        );
        return ["Yönetim İşleri", "Operasyonel İşler"].includes(
          String(parent?.name || "")
        );
      }) || childTypes[0];

    setForm((f) => ({
      ...f,
      work_type_id: isOther ? fallbackOtherType?.id || "" : "",
      publisher_user_id: "",
      publisher_hidden_id: "",
      publisher_username: "",
      publisher_name: "",
      title: "",
      description: "",
      where_left_off: "",
      next_action: "",
      due_at: nowDateTimeLocal(),
      reminder_enabled: false,
      reminder_at: "",
    }));
    setPublisherScope("");
    setPublisherSearch("");
    setPublisherSearchOpen(false);
    setShowNew(true);
  }

  function resetNewForm() {
    setPublisherScope("");
    setPublisherSearch("");
    setPublisherSearchOpen(false);
    setForm({
      work_type_id: "",
      publisher_user_id: "",
      publisher_hidden_id: "",
      publisher_username: "",
      publisher_name: "",
      title: "",
      description: "",
      status: "waiting",
      priority: "normal",
      owner_username: currentUsername,
      start_at: "",
      due_at: nowDateTimeLocal(),
      next_action: "",
      next_action_at: "",
      where_left_off: "",
      reminder_enabled: false,
      reminder_at: "",
      reminder_repeat: "none",
      reminder_target_username: currentUsername,
    });
  }

  async function saveWork(e) {
    e.preventDefault();
    try {
      await jsonFetch(API.save, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...form, actor_username: currentUsername }),
      });
      setShowNew(false);
      setSelectedMainType("");
      resetNewForm();
      await load();
    } catch (e2) {
      setError(e2.message || "İş kaydedilemedi.");
    }
  }

  async function saveAction(e) {
    e.preventDefault();
    if (!selected) return;
    try {
      await jsonFetch(API.actionSave, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...action,
          work_item_id: selected,
          actor_username: currentUsername,
        }),
      });
      setAction({
        action_type: "note",
        action_text: "",
        result_text: "",
        next_action: "",
        next_action_at: "",
        where_left_off: "",
      });
      await openDetail(selected);
      await load();
    } catch (e2) {
      setError(e2.message || "İşlem kaydedilemedi.");
    }
  }

  async function deleteItem(id = selected) {
    if (!id) return;
    if (!window.confirm("Seçili iş kaydı silinsin mi?")) return;
    try {
      await jsonFetch(API.delete, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ work_item_id: id, actor_username: currentUsername }),
      });
      if (Number(id) === Number(selected)) closeDetail();
      await load();
    } catch (e) {
      setError(e.message || "İş silinemedi.");
    }
  }

  async function completeItem(id = selected) {
    if (!id) return;
    try {
      await jsonFetch(API.complete, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          work_item_id: id,
          actor_username: currentUsername,
        }),
      });
      if (Number(id) === Number(selected)) closeDetail();
      await load();
    } catch (e) {
      setError(e.message || "İş tamamlanamadı.");
    }
  }

  async function transferSelected() {
    if (!selectedTransferIds.length) {
      setError("Devretmek için en az bir iş seçmelisiniz.");
      return;
    }

    if (!transferTarget) {
      setError("Yeni sorumlu yöneticiyi seçmelisiniz.");
      return;
    }

    try {
      setError("");

      for (const id of selectedTransferIds) {
        await jsonFetch(API.transfer, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            work_item_id: id,
            to_username: transferTarget,
            reason: transferReason,
            actor_username: currentUsername,
          }),
        });
      }

      setSelectedTransferIds([]);
      setTransferTarget("");
      setTransferReason("");
      await load();
    } catch (e) {
      setError(e.message || "İş devri tamamlanamadı.");
    }
  }

  async function transfer() {
    if (!selected) return;
    const to = window.prompt("Yeni sorumlu kullanıcı adı:");
    if (!to) return;
    const reason = window.prompt("Devir nedeni:") || "";

    try {
      await jsonFetch(API.transfer, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          work_item_id: selected,
          to_username: to,
          reason,
          actor_username: currentUsername,
        }),
      });
      await openDetail(selected);
      await load();
    } catch (e) {
      setError(e.message || "İş devredilemedi.");
    }
  }

  function openQuickReminder(workItem = null) {
    const preferred =
      workItem ||
      (selectedPerson
        ? items.find(
            (item) =>
              String(item.publisher_username || "") ===
              String(selectedPerson.username || "")
          )
        : null);

    setReminderForm({
      work_item_id: preferred?.id ? String(preferred.id) : "",
      reminder_at: nowDateTimeLocal(),
      note: "",
    });
    setShowReminderModal(true);
  }

  async function saveReminder(e) {
    e.preventDefault();

    if (!reminderForm.work_item_id) {
      setError("Hatırlatma için bir iş seçmelisiniz.");
      return;
    }

    try {
      await jsonFetch(API.reminderSave, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...reminderForm,
          reminder_target_username: currentUsername,
          actor_username: currentUsername,
        }),
      });

      setShowReminderModal(false);
      setReminderForm({ work_item_id: "", reminder_at: "", note: "" });
      await load();
    } catch (e2) {
      setError(e2.message || "Hatırlatma kaydedilemedi.");
    }
  }

  const pageTitle =
    moduleMode === "reminders"
      ? "Hatırlatmalar"
      : moduleMode === "transfer"
        ? "İş Devri"
        : moduleMode === "reports"
          ? "Raporlar"
          : moduleMode === "performance"
            ? "Performans"
            : "Planlanan / Gerçekleşen Çalışmalar";

  return (
    <>
      <style>{WORKSPACE_CSS}</style>

      <section className="wm-workspace">
        <div className="wm-workspace-topbar">
          <strong>WOLF MEDIA Yönetim Paneli</strong>
          <span style={{ fontSize: 10, opacity: 0.72 }}>
            {currentUsername || "Yönetici"}
          </span>
        </div>

        <div className={`wm-workspace-body${helperPanelOpen ? " helper-open" : ""}`}>
          <aside className="wm-focus-rail">
            {!helperPanelOpen ? (
              <div className="wm-helper-collapsed">
                <button
                  type="button"
                  className="wm-helper-tab"
                  onClick={() => setHelperPanelOpen(true)}
                  title="Takvimi aç"
                >
                  Takvim
                </button>
                <button
                  type="button"
                  className="wm-helper-tab"
                  onClick={() => setHelperPanelOpen(true)}
                  title="Hatırlatmaları aç"
                >
                  Hatırlatmalar
                  <span className="wm-helper-badge">{reminderCount}</span>
                </button>
              </div>
            ) : (
              <div className="wm-helper-open">
                <div className="wm-helper-open-head">
                  <strong>Takvim & Hatırlatmalar ({reminderCount})</strong>
                  <button
                    type="button"
                    className="wm-helper-close"
                    onClick={() => setHelperPanelOpen(false)}
                  >
                    Kapat
                  </button>
                </div>

                {selectedPerson ? (
                  <div className="wm-selected-person">
                    <div className="name">
                      {selectedPerson.username || selectedPerson.fullName || "-"}
                    </div>
                    <div className="meta">
                      {selectedPerson.fullName || selectedPerson.full_name || ""}
                    </div>
                    <div className="actions">
                      <button
                        type="button"
                        onClick={() => {
                          setSelectedPerson(null);
                          setPersonSearch("");
                          setPersonPickerOpen(true);
                        }}
                      >
                        Kişi değiştir
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          setSelectedPerson(null);
                          setPersonSearch("");
                          setPersonPickerOpen(false);
                        }}
                      >
                        Temizle
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="wm-person-picker">
                    <div className="wm-person-search">
                      <span>⌕</span>
                      <input
                        value={personSearch}
                        onFocus={() => setPersonPickerOpen(true)}
                        onChange={(e) => {
                          setPersonSearch(e.target.value);
                          setPersonPickerOpen(true);
                        }}
                        placeholder="Kişi seç / kişi ara..."
                        autoComplete="off"
                      />
                    </div>

                    {personPickerOpen ? (
                      <div className="wm-person-results">
                        {personOptions.map((person) => (
                          <button
                            type="button"
                            className="wm-person-option"
                            key={person.id || person.username}
                            onClick={() => {
                              setSelectedPerson(person);
                              setPersonSearch("");
                              setPersonPickerOpen(false);
                            }}
                          >
                            <strong>{person.username || "-"}</strong>
                            <span>{person.fullName || person.full_name || "-"}</span>
                          </button>
                        ))}

                        {personOptions.length === 0 ? (
                          <div style={{ padding: 10, fontSize: 10, color: "#8c8378" }}>
                            Eşleşen yayıncı bulunamadı.
                          </div>
                        ) : null}
                      </div>
                    ) : null}
                  </div>
                )}

                <div className="wm-calendar">
                  <div className="wm-calendar-head">
                    <button type="button" onClick={() => moveMonth(-1)}>‹</button>
                    <span>
                      {calendarMonth.toLocaleDateString("tr-TR", {
                        month: "long",
                        year: "numeric",
                      })}
                    </span>
                    <button type="button" onClick={() => moveMonth(1)}>›</button>
                  </div>

                  <div className="wm-calendar-week">
                    {["Pt", "Sa", "Ça", "Pe", "Cu", "Ct", "Pz"].map((d) => (
                      <span key={d}>{d}</span>
                    ))}
                  </div>

                  <div className="wm-calendar-grid">
                    {calendarCells.map((date, index) => {
                      if (!date) {
                        return <span key={`e-${index}`} className="wm-day is-empty">0</span>;
                      }

                      const key = toDateKey(date);
                      const todayKey = toDateKey(today);
                      const selectedClass = key === selectedDate ? " is-selected" : "";
                      const todayClass = key === todayKey ? " is-today" : "";

                      return (
                        <button
                          key={key}
                          type="button"
                          className={`wm-day${selectedClass}${todayClass}`}
                          onClick={() => setSelectedDate(key)}
                        >
                          {date.getDate()}
                        </button>
                      );
                    })}
                  </div>
                </div>

                <div className="wm-reminder-title">
                  <span>Hatırlatıcı</span>
                  <button
                    type="button"
                    onClick={() => openQuickReminder()}
                    style={{
                      border: 0,
                      background: "transparent",
                      cursor: "pointer",
                      color: "#7f621a",
                      fontWeight: 900,
                      padding: 0,
                      minHeight: 20,
                    }}
                  >
                    + ekle
                  </button>
                </div>

                {dueReminders.length > 0 ? (
                  <div className="wm-reminder-alert">
                    <div className="wm-reminder-alert-title">
                      <span>Zamanı Gelen / Geçen Hatırlatmalar</span>
                      <span>{dueReminders.length}</span>
                    </div>

                    {dueReminders.slice(0, 6).map((item) => (
                      <button
                        key={`due-${item.id}`}
                        type="button"
                        className="wm-reminder-alert-item"
                        onClick={() => openDetail(item.id)}
                      >
                        <strong>{item.title}</strong>
                        <span>
                          {showDate(item.reminder_at)}
                          {item.publisher_username
                            ? ` · ${item.publisher_username}`
                            : ""}
                        </span>
                      </button>
                    ))}
                  </div>
                ) : null}

                <div className="wm-reminder-list">
                  {reminders.length === 0 ? (
                    <div className="wm-reminder-empty">
                      Yaklaşan hatırlatıcı yok.
                    </div>
                  ) : (
                    reminders.map((item) => (
                      <button
                        key={item.id}
                        type="button"
                        className="wm-reminder-card"
                        onClick={() => openDetail(item.id)}
                      >
                        <div className="t">{item.title}</div>
                        <div className="m">
                          {showDate(item.reminder_at)}
                          {item.publisher_username ? ` · ${item.publisher_username}` : ""}
                        </div>
                        {item.reminder_note ? (
                          <div className="m">{item.reminder_note}</div>
                        ) : null}
                      </button>
                    ))
                  )}
                </div>
              </div>
            )}
          </aside>

          <main className="wm-main">
            <div className="wm-main-head">
              <div>
                <div className="wm-kicker">İş Yönetimi</div>
                <div className="wm-user-line">
                  Kullanıcı: {currentUsername || "Yönetici"}
                </div>
                <div className="wm-main-title">{pageTitle}</div>
                <div className="wm-main-sub">
                  {new Date(`${selectedDate}T12:00:00`).toLocaleDateString(
                    "tr-TR",
                    {
                      weekday: "long",
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                    }
                  )}
                </div>
              </div>

              <button
                type="button"
                className="wm-new-button"
                onClick={() => {
                  if (showNew) {
                    setShowNew(false);
                    setSelectedMainType("");
                    resetNewForm();
                    return;
                  }
                  resetNewForm();
                  setSelectedMainType("");
                  setShowNew(true);
                }}
              >
                {showNew ? "Kaydı Kapat" : "+ Yeni İş"}
              </button>
            </div>

            {error ? (
              <div
                style={{
                  marginTop: 12,
                  borderLeft: "3px solid #a33b33",
                  background: "#fff3f1",
                  padding: "9px 11px",
                  fontSize: 10,
                  color: "#7b302a",
                }}
              >
                {error}
              </div>
            ) : null}

            {moduleMode === "desk" ? (
            <div className="wm-search-and-types">
              <div className="wm-search-wide">
                <span style={{ color: "#8a8177" }}>⌕</span>
                <input
                  value={q}
                  onChange={(e) => setQ(e.target.value)}
                  placeholder="Yayıncı / iş ara..."
                />
              </div>

              <div
                className="wm-work-category-strip"
                style={{
                  gridTemplateColumns: `repeat(${Math.max(topTypes.length, 1)}, minmax(110px, 1fr))`,
                }}
              >
                {topTypes.map((type) => (
                  <button
                    type="button"
                    key={type.id}
                    className={
                      String(selectedMainType) === String(type.id)
                        ? "is-active"
                        : ""
                    }
                    onClick={() => chooseMainType(type.id)}
                  >
                    {type.name}
                  </button>
                ))}
              </div>
            </div>

            ) : null}

            {moduleMode === "desk" ? (
              <>
                <div className="wm-overview-strip">
                  <div className="wm-overview-pill">
                    <div className="n">{openCount}</div>
                    <div className="l">Açık İş</div>
                  </div>
                  <div className="wm-overview-pill">
                    <div className="n">{todayCount}</div>
                    <div className="l">Bugün</div>
                  </div>
                  <div className="wm-overview-pill">
                    <div className="n">{overdueCount}</div>
                    <div className="l">Geciken</div>
                  </div>
                  <div className="wm-overview-pill">
                    <div className="n">{reminderCount}</div>
                    <div className="l">Hatırlatma</div>
                  </div>
                </div>

                <div className="wm-module-toolbar">
                  {[
                    ["all", "Tümü"],
                    ["today", "Bugün"],
                    ["yesterday", "Dün"],
                    ["week", "Son 7 Gün"],
                  ].map(([key, label]) => (
                    <button
                      key={key}
                      type="button"
                      className={`wm-filter-btn${deskFilter === key ? " is-active" : ""}`}
                      onClick={() => {
                        setDeskFilter(key);
                        setShowAllDeskItems(false);
                      }}
                    >
                      {label}
                    </button>
                  ))}

                  <button
                    type="button"
                    className={`wm-filter-btn${deskFilter === "date" ? " is-active" : ""}`}
                    onClick={() => setDeskFilter("date")}
                  >
                    Tarih
                  </button>

                  {deskFilter === "date" ? (
                    <input
                      type="date"
                      className="wm-date-filter"
                      value={deskDate}
                      onChange={(e) => {
                        setDeskDate(e.target.value);
                        setShowAllDeskItems(false);
                      }}
                    />
                  ) : null}

                  <span className="wm-module-note">
                    {deskFilteredItems.length} kayıt · İlk 10 iş ön görünümde
                  </span>
                </div>

                <div className="wm-workarea-shell">
                  <div className="wm-work-grid">
                    <div className="wm-work-grid-header">
                      <div></div>
                      <div>Saat</div>
                      <div>Yayıncı / Konu</div>
                      <div>Ana İş</div>
                      <div>Alt İş</div>
                      <div>Sorumlu</div>
                      <div>Oluşturma Tarihi</div>
                      <div>Termin</div>
                      <div>Durum</div>
                      <div>Öncelik</div>
                    </div>

                    {showNew ? (
                      <div className="wm-work-grid-newrow">
                        <div></div>

                        <div>
                          <input
                            type="time"
                            value={form.due_at ? String(form.due_at).slice(11, 16) : ""}
                            onChange={(e) => {
                              const d = form.due_at?.slice(0, 10) || toDateKey(today);
                              setForm((f) => ({ ...f, due_at: `${d}T${e.target.value}` }));
                            }}
                          />
                        </div>

                        <div>
                          <input
                            required
                            value={form.title}
                            onChange={(e) =>
                              setForm((f) => ({ ...f, title: e.target.value }))
                            }
                            placeholder="Konu / iş başlığı"
                          />
                          <input
                            value={publisherSearch}
                            onFocus={() => setPublisherSearchOpen(true)}
                            onChange={(e) => {
                              setPublisherSearch(e.target.value);
                              setPublisherSearchOpen(true);
                              setForm((f) => ({
                                ...f,
                                publisher_user_id: "",
                                publisher_hidden_id: "",
                                publisher_username: "",
                                publisher_name: "",
                              }));
                            }}
                            placeholder="Yayıncı ara"
                            autoComplete="off"
                          />

                          {publisherSearchOpen ? (
                            <div className="wm-grid-inline-results">
                              <button
                                type="button"
                                onClick={() => {
                                  setPublisherSearch("");
                                  setPublisherSearchOpen(false);
                                }}
                              >
                                <strong>Genel iş</strong>
                                <span>Yayıncı seçmeden devam et</span>
                              </button>

                              {(publisherScope ? filteredManagerPublishers : personOptions).map((p) => (
                                <button
                                  key={p.id || p.username}
                                  type="button"
                                  onClick={() => selectPublisher(p)}
                                >
                                  <strong>{p.username || "-"}</strong>
                                  <span>{p.fullName || p.full_name || "-"}</span>
                                </button>
                              ))}
                            </div>
                          ) : null}
                        </div>

                        <div>
                          <select
                            required
                            value={selectedMainType}
                            onChange={(e) => chooseMainType(e.target.value)}
                          >
                            <option value="">Ana iş seçin</option>
                            {topTypes.map((type) => (
                              <option key={type.id} value={type.id}>
                                {type.name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div>
                          {String(selectedMainType) === "__other__" ? (
                            <input
                              value={form.description}
                              onChange={(e) =>
                                setForm((f) => ({ ...f, description: e.target.value }))
                              }
                              placeholder="Diğer iş türü"
                            />
                          ) : (
                            <select
                              required
                              value={form.work_type_id}
                              onChange={(e) =>
                                setForm((f) => ({ ...f, work_type_id: e.target.value }))
                              }
                            >
                              <option value="">Alt iş seçin</option>
                              {childTypes
                                .filter(
                                  (child) =>
                                    String(child.parent_id) === String(selectedMainType)
                                )
                                .map((child) => (
                                  <option key={child.id} value={child.id}>
                                    {child.name}
                                  </option>
                                ))}
                            </select>
                          )}
                        </div>

                        <div>
                          <select
                            required
                            value={publisherScope}
                            onChange={(e) => selectManager(e.target.value)}
                          >
                            <option value="">Sorumlu seçin</option>
                            {managers.map((m) => (
                              <option key={m.id || m.username} value={m.username}>
                                {m.fullName || m.full_name || m.username}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div>
                          <input
                            value={new Date().toLocaleString("tr-TR")}
                            readOnly
                          />
                        </div>

                        <div>
                          <input
                            type="datetime-local"
                            value={form.due_at}
                            onChange={(e) =>
                              setForm((f) => ({ ...f, due_at: e.target.value }))
                            }
                          />
                        </div>

                        <div>
                          <select
                            value={form.status}
                            onChange={(e) =>
                              setForm((f) => ({ ...f, status: e.target.value }))
                            }
                          >
                            <option value="waiting">Kapalı</option>
                            <option value="open">Açık</option>
                          </select>
                        </div>

                        <div>
                          <select
                            value={form.priority}
                            onChange={(e) =>
                              setForm((f) => ({ ...f, priority: e.target.value }))
                            }
                          >
                            <option value="low">Düşük</option>
                            <option value="normal">Normal</option>
                            <option value="high">Yüksek</option>
                            <option value="critical">Kritik</option>
                          </select>
                        </div>
                      </div>
                    ) : null}

                    {deskPreviewItems.map((item) => {
                      const targetDate = item.next_action_at || item.due_at;
                      const overdue = isOverdue(item);

                      return (
                        <div
                          key={item.id}
                          className={`wm-work-grid-row${
                            Number(selected) === Number(item.id) ? " is-selected" : ""
                          }${overdue ? " is-overdue" : ""}`}
                          onClick={() => openDetail(item.id)}
                        >
                          <div style={{ justifyContent: "center", padding: 0 }}>
                            <button
                              type="button"
                              title="Tamamla"
                              onClick={(e) => {
                                e.stopPropagation();
                                completeItem(item.id);
                              }}
                              style={{
                                width: 16,
                                height: 16,
                                minHeight: 16,
                                padding: 0,
                                borderRadius: "50%",
                                border: "1px solid #aaa094",
                                background: "#fff",
                              }}
                            />
                          </div>
                          <div>{showTime(targetDate)}</div>
                          <div style={{ display: "block", paddingTop: 6 }}>
                            <strong>{item.title}</strong>
                            <div style={{ marginTop: 2, fontSize: 9, color: "#8a8176" }}>
                              {item.publisher_name ||
                                item.publisher_username ||
                                item.work_no}
                            </div>
                          </div>
                          <div>{item.parent_type_name || "-"}</div>
                          <div>{item.work_type_name || "-"}</div>
                          <div>{item.owner_username || "-"}</div>
                          <div>{showDate(item.created_at)}</div>
                          <div>{showDate(targetDate)}</div>
                          <div>{statusText[item.status] || item.status || "-"}</div>
                          <div>
                            {overdue
                              ? "Gecikti"
                              : priorityText[item.priority] || item.priority || "-"}
                          </div>
                        </div>
                      );
                    })}

                    {!showNew && deskPreviewItems.length === 0 ? (
                      <div
                        style={{
                          minWidth: 1180,
                          padding: "34px 16px",
                          textAlign: "center",
                          color: "#948b80",
                          fontSize: 11,
                          background: "#fff",
                        }}
                      >
                        Bu görünümde kayıt bulunmuyor.
                      </div>
                    ) : null}
                  </div>
                </div>

                {deskFilteredItems.length > 10 ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      padding: "9px 0 2px",
                    }}
                  >
                    <button
                      type="button"
                      className="wm-filter-btn"
                      onClick={() => setShowAllDeskItems((v) => !v)}
                    >
                      {showAllDeskItems
                        ? "İlk 10 İşe Dön"
                        : `Diğer ${deskFilteredItems.length - 10} İşi Göster`}
                    </button>
                  </div>
                ) : null}

                {stale.length > 0 ? (
                  <div className="wm-stale-bar">
                    <strong>{stale.length} yayıncı</strong> 15 gündür işlem görmemiş.
                  </div>
                ) : null}
              </>
            ) : null}

            {moduleMode === "reminders" ? (
              <div className="wm-reminder-dashboard">
                <section className="wm-module-card">
                  <h3>Zamanı Gelen / Geçen ({dueReminders.length})</h3>
                  <div className="wm-module-card-body">
                    {dueReminders.length ? (
                      dueReminders.map((item) => (
                        <div
                          key={`due-${item.id}`}
                          className="wm-reminder-row"
                          onClick={() => openDetail(item.id)}
                        >
                          <strong>{item.title}</strong>
                          <span>{showDate(item.reminder_at)}</span>
                          <span>
                            {item.publisher_username || item.owner_username || "-"}
                          </span>
                        </div>
                      ))
                    ) : (
                      <div className="wm-module-note">
                        Zamanı geçen hatırlatma yok.
                      </div>
                    )}
                  </div>
                </section>

                <section className="wm-module-card">
                  <h3>Yaklaşan Hatırlatmalar ({futureReminders.length})</h3>
                  <div className="wm-module-card-body">
                    {futureReminders.slice(0, 12).map((item) => (
                      <div
                        key={`future-${item.id}`}
                        className="wm-reminder-row"
                        onClick={() => openDetail(item.id)}
                      >
                        <strong>{item.title}</strong>
                        <span>{showDate(item.reminder_at)}</span>
                        <span>
                          {item.publisher_username || item.owner_username || "-"}
                        </span>
                      </div>
                    ))}
                  </div>
                </section>

                <section className="wm-module-card">
                  <h3>Hatırlatma Özeti</h3>
                  <div className="wm-module-card-body">
                    <div className="wm-kpi-line">
                      <span>Toplam</span>
                      <strong>{reminderCount}</strong>
                    </div>
                    <div className="wm-kpi-line">
                      <span>Zamanı Gelen / Geçen</span>
                      <strong>{dueReminders.length}</strong>
                    </div>
                    <div className="wm-kpi-line">
                      <span>Yaklaşan</span>
                      <strong>{futureReminders.length}</strong>
                    </div>
                    <div className="wm-kpi-line">
                      <span>Bugün</span>
                      <strong>
                        {
                          items.filter(
                            (x) =>
                              Number(x.reminder_enabled) === 1 &&
                              toDateKey(x.reminder_at) === toDateKey(today)
                          ).length
                        }
                      </strong>
                    </div>
                    <button
                      type="button"
                      className="wm-btn-primary"
                      style={{ width: "100%", marginTop: 10 }}
                      onClick={() => openQuickReminder()}
                    >
                      + Hatırlatma Ekle
                    </button>
                  </div>
                </section>
              </div>
            ) : null}

            {moduleMode === "transfer" ? (
              <div className="wm-transfer-layout">
                <section className="wm-module-card">
                  <h3>Devredilecek İşleri Seç</h3>
                  <div className="wm-transfer-row header">
                    <div></div>
                    <div>İş No</div>
                    <div>İş / Konu</div>
                    <div>Sorumlu</div>
                    <div>Durum</div>
                  </div>

                  {items
                    .filter(
                      (item) =>
                        item.status !== "completed" &&
                        item.status !== "cancelled"
                    )
                    .map((item) => (
                      <div className="wm-transfer-row" key={`transfer-${item.id}`}>
                        <div>
                          <input
                            type="checkbox"
                            checked={selectedTransferIds.includes(item.id)}
                            onChange={(e) =>
                              setSelectedTransferIds((list) =>
                                e.target.checked
                                  ? [...list, item.id]
                                  : list.filter(
                                      (id) => Number(id) !== Number(item.id)
                                    )
                              )
                            }
                          />
                        </div>
                        <div>{item.work_no || item.id}</div>
                        <div>{item.title}</div>
                        <div>{item.owner_username || "-"}</div>
                        <div>{statusText[item.status] || item.status}</div>
                      </div>
                    ))}
                </section>

                <aside className="wm-module-card">
                  <h3>Devir Bilgileri</h3>
                  <div className="wm-transfer-side">
                    <div className="wm-module-note" style={{ marginBottom: 8 }}>
                      Seçili iş: {selectedTransferIds.length}
                    </div>

                    <select
                      value={transferTarget}
                      onChange={(e) => setTransferTarget(e.target.value)}
                    >
                      <option value="">Yeni sorumlu yönetici</option>
                      {managers.map((m) => (
                        <option key={m.id || m.username} value={m.username}>
                          {m.fullName || m.full_name || m.username}
                        </option>
                      ))}
                    </select>

                    <textarea
                      value={transferReason}
                      onChange={(e) => setTransferReason(e.target.value)}
                      placeholder="Devir nedeni / not"
                    />

                    <button
                      type="button"
                      className="wm-btn-primary"
                      style={{ width: "100%" }}
                      onClick={transferSelected}
                    >
                      Seçili İşleri Devret
                    </button>
                  </div>
                </aside>
              </div>
            ) : null}

            {moduleMode === "reports" ? (
              <div className="wm-report-grid">
                {[
                  ["Toplam İş", reportSummary.total],
                  ["Tamamlanan", reportSummary.completed],
                  ["Açık / Devam Eden", reportSummary.open],
                  ["Geciken", reportSummary.overdue],
                ].map(([label, value]) => (
                  <section className="wm-module-card" key={label}>
                    <div className="wm-module-card-body">
                      <div className="wm-report-number">{value}</div>
                      <div className="wm-report-label">{label}</div>
                    </div>
                  </section>
                ))}

                <section className="wm-module-card wm-report-wide">
                  <h3>İş Tiplerine Göre Dağılım</h3>
                  <div className="wm-module-card-body">
                    {reportSummary.byType.map((row) => (
                      <div className="wm-kpi-line" key={row.name}>
                        <span>{row.name}</span>
                        <strong>{row.count}</strong>
                      </div>
                    ))}
                  </div>
                </section>

                <section className="wm-module-card wm-report-wide">
                  <h3>Genel Durum</h3>
                  <div className="wm-module-card-body">
                    <div className="wm-kpi-line">
                      <span>Tamamlanma Oranı</span>
                      <strong>%{reportSummary.completionRate}</strong>
                    </div>
                    <div className="wm-kpi-line">
                      <span>Kritik Öncelik</span>
                      <strong>{reportSummary.critical}</strong>
                    </div>
                    <div className="wm-kpi-line">
                      <span>Hatırlatma</span>
                      <strong>{reminderCount}</strong>
                    </div>
                    <div className="wm-kpi-line">
                      <span>15+ Gün Dokunulmayan Yayıncı</span>
                      <strong>{stale.length}</strong>
                    </div>
                  </div>
                </section>
              </div>
            ) : null}

            {moduleMode === "performance" ? (
              <div className="wm-performance-table">
                <div className="wm-performance-row header">
                  <div>Yönetici</div>
                  <div>Toplam</div>
                  <div>Tamamlanan</div>
                  <div>Açık</div>
                  <div>Geciken</div>
                  <div>Başarı</div>
                </div>

                {managerPerformance.map((row) => (
                  <div className="wm-performance-row" key={row.manager}>
                    <div>
                      <strong>{row.manager}</strong>
                    </div>
                    <div>{row.total}</div>
                    <div>{row.completed}</div>
                    <div>{row.open}</div>
                    <div>{row.overdue}</div>
                    <div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: 4,
                        }}
                      >
                        <span>%{row.completionRate}</span>
                        <span>{row.reminders} hatırlatma</span>
                      </div>
                      <div className="wm-progress">
                        <span style={{ width: `${row.completionRate}%` }} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : null}
          </main>
        </div>
      </section>

      {detail ? (
        <div
          className="wm-drawer-backdrop"
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) closeDetail();
          }}
        >
          <aside className="wm-drawer">
            <div className="wm-drawer-head">
              <div>
                <div className="wm-kicker">{detail.item.work_no}</div>
                <div style={{ marginTop: 5, fontSize: 20, fontWeight: 900 }}>
                  {detail.item.title}
                </div>
                <div style={{ marginTop: 4, fontSize: 10, color: "#81786f" }}>
                  {detail.item.publisher_name ||
                    detail.item.publisher_username ||
                    "Genel İş"}
                </div>
              </div>
              <button
                type="button"
                className="wm-drawer-close"
                onClick={closeDetail}
              >
                Kapat
              </button>
            </div>

            {detail.item.description ? (
              <div
                style={{
                  marginTop: 14,
                  padding: 11,
                  border: "1px solid #ddd6cc",
                  background: "#fff",
                  fontSize: 11,
                  lineHeight: 1.6,
                }}
              >
                <div
                  style={{
                    fontSize: 9,
                    color: "#8b8177",
                    textTransform: "uppercase",
                    letterSpacing: ".1em",
                    marginBottom: 4,
                    fontWeight: 800,
                  }}
                >
                  Açıklama
                </div>
                {detail.item.description}
              </div>
            ) : null}

            <div className="wm-detail-grid">
              <div className="wm-detail-field">
                <div className="k">Sorumlu</div>
                <div className="v">{detail.item.owner_username || "-"}</div>
              </div>
              <div className="wm-detail-field">
                <div className="k">Durum</div>
                <div className="v">
                  {statusText[detail.item.status] || detail.item.status}
                </div>
              </div>
              <div className="wm-detail-field">
                <div className="k">Nerede kaldı</div>
                <div className="v">
                  {detail.item.where_left_off || "-"}
                </div>
              </div>
              <div className="wm-detail-field">
                <div className="k">Sonraki aksiyon</div>
                <div className="v">{detail.item.next_action || "-"}</div>
              </div>
              <div className="wm-detail-field">
                <div className="k">Termin</div>
                <div className="v">
                  {showDate(
                    detail.item.next_action_at || detail.item.due_at
                  )}
                </div>
              </div>
              <div className="wm-detail-field">
                <div className="k">Hatırlatma</div>
                <div className="v">
                  {Number(detail.item.reminder_enabled) === 1
                    ? showDate(detail.item.reminder_at)
                    : "Kapalı"}
                </div>
              </div>
            </div>

            <div style={{ display: "flex", gap: 7 }}>
              <button
                type="button"
                className="wm-btn-secondary"
                onClick={transfer}
              >
                Devret
              </button>
              <button
                type="button"
                className="wm-btn-primary"
                onClick={() => completeItem()}
              >
                Tamamla
              </button>
            </div>

            <form onSubmit={saveAction} className="wm-action-form">
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 900,
                  marginBottom: 8,
                }}
              >
                Yeni işlem ekle
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "150px 1fr",
                  gap: 8,
                  marginBottom: 8,
                }}
              >
                <select
                  value={action.action_type}
                  onChange={(e) =>
                    setAction((a) => ({
                      ...a,
                      action_type: e.target.value,
                    }))
                  }
                >
                  <option value="note">Not</option>
                  <option value="call">Arama</option>
                  <option value="meeting">Toplantı</option>
                  <option value="message">Mesaj</option>
                  <option value="control">Kontrol</option>
                  <option value="decision">Karar</option>
                </select>

                <input
                  value={action.next_action}
                  onChange={(e) =>
                    setAction((a) => ({
                      ...a,
                      next_action: e.target.value,
                    }))
                  }
                  placeholder="Sonraki aksiyon"
                />
              </div>

              <textarea
                required
                value={action.action_text}
                onChange={(e) =>
                  setAction((a) => ({
                    ...a,
                    action_text: e.target.value,
                  }))
                }
                placeholder="Ne yapıldı?"
              />

              <textarea
                value={action.result_text}
                onChange={(e) =>
                  setAction((a) => ({
                    ...a,
                    result_text: e.target.value,
                  }))
                }
                placeholder="Sonuç / nerede kaldı"
                style={{ marginTop: 8 }}
              />

              <input
                type="datetime-local"
                value={action.next_action_at}
                onChange={(e) =>
                  setAction((a) => ({
                    ...a,
                    next_action_at: e.target.value,
                  }))
                }
                style={{ marginTop: 8 }}
              />

              <button className="wm-save-action" style={{ marginTop: 8 }}>
                İşlemi Kaydet
              </button>
            </form>

            <div className="wm-timeline">
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 900,
                  marginBottom: 10,
                }}
              >
                İşlem Geçmişi
              </div>

              {(detail.actions || []).length === 0 ? (
                <div style={{ fontSize: 10, color: "#8c8378" }}>
                  Henüz işlem kaydı yok.
                </div>
              ) : (
                (detail.actions || []).map((item) => (
                  <div className="wm-timeline-item" key={item.id}>
                    <div className="wm-timeline-meta">
                      {item.actor_username} · {showDate(item.created_at)}
                    </div>
                    <div className="wm-timeline-text">
                      {item.action_text}
                    </div>
                    {item.result_text ? (
                      <div
                        className="wm-timeline-text"
                        style={{ color: "#756b61" }}
                      >
                        Sonuç: {item.result_text}
                      </div>
                    ) : null}
                  </div>
                ))
              )}
            </div>
          </aside>
        </div>
      ) : null}

      {showReminderModal ? (
        <div className="wm-modal-backdrop">
          <form className="wm-reminder-modal" onSubmit={saveReminder}>
            <div className="wm-drawer-head">
              <div>
                <div className="wm-kicker">Hatırlatıcı</div>
                <div style={{ marginTop: 5, fontSize: 19, fontWeight: 900 }}>
                  Hatırlatma Oluştur
                </div>
              </div>
              <button
                type="button"
                className="wm-drawer-close"
                onClick={() => setShowReminderModal(false)}
              >
                Kapat
              </button>
            </div>

            <div className="wm-reminder-form">
              <label>
                <span>İşlerden Seç</span>
                <select
                  required
                  value={reminderForm.work_item_id}
                  onChange={(e) =>
                    setReminderForm((f) => ({
                      ...f,
                      work_item_id: e.target.value,
                    }))
                  }
                >
                  <option value="">İş seçin</option>
                  {items
                    .filter(
                      (item) =>
                        item.status !== "completed" &&
                        item.status !== "cancelled" &&
                        (!selectedPerson ||
                          String(item.publisher_username || "") ===
                            String(selectedPerson.username || ""))
                    )
                    .map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.work_no} · {item.title}
                        {item.publisher_username
                          ? ` · ${item.publisher_username}`
                          : ""}
                      </option>
                    ))}
                </select>
              </label>

              <label>
                <span>Tarih / Saat</span>
                <input
                  required
                  type="datetime-local"
                  value={reminderForm.reminder_at}
                  onChange={(e) =>
                    setReminderForm((f) => ({
                      ...f,
                      reminder_at: e.target.value,
                    }))
                  }
                />
              </label>

              <label>
                <span>Not</span>
                <textarea
                  value={reminderForm.note}
                  onChange={(e) =>
                    setReminderForm((f) => ({
                      ...f,
                      note: e.target.value,
                    }))
                  }
                  placeholder="Hatırlatmada görünmesini istediğiniz kısa not"
                />
              </label>
            </div>

            <div className="wm-modal-actions">
              <button
                type="button"
                className="wm-btn-secondary"
                onClick={() => setShowReminderModal(false)}
              >
                Vazgeç
              </button>
              <button className="wm-btn-primary">Hatırlatıcıyı Kaydet</button>
            </div>
          </form>
        </div>
      ) : null}

    </>
  );
}
